import styled from "styled-components";
import { useState, useEffect } from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import { captureException } from "@sentry/react";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";

import RewardHistory from "./RewardHistory";
import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";

export default () => {
  const [page, setPage] = useState(1);

  const LayoutProperties = createSelector(
    (state) => state.Layout,
    (user) => ({
      telegramRewardListUpdated: user.telegramRewardListUpdated,
    })
  );

  const { telegramRewardListUpdated } = useSelector(LayoutProperties);

  // Fetch data
  const REWARD_HISTORY_DATA = gql`
    query GetTelegramRewardHistoryData($page: Int!) {
      telegramRewardHistory(page: $page) {
        rewards {
          id
          posted_at
          reward
          number_of_rewards
          streak_requirement
          claims {
            id
            username
            profile_image
          }
        }
        numOfResults
      }
    }
  `;

  const { data, error, refetch } = useQuery(REWARD_HISTORY_DATA, {
    fetchPolicy: "network-only",
    variables: { page },
  });

  if (error) {
    console.log("fetching reward history data error", error);
    captureException(error);
  }

  // refetch data on update from claimrewardcontainer
  useEffect(() => {
    //console.log("REFETCHING", telegramRewardListUpdated);
    if (telegramRewardListUpdated) {
      console.log("REFETCHING", telegramRewardListUpdated);
      refetch();
    }
  }, [telegramRewardListUpdated]);

  const paginate = (where) => {
    if (where === "previous") setPage((prevState) => prevState - 1);
    if (where === "next") setPage((prevState) => prevState + 1);
  };

  console.log("data", data);

  return (
    <>
      {!data && (
        <LoadingBox>
          <BoxLoadingSpinner height="1600px" />
        </LoadingBox>
      )}
      {data && (
        <RewardHistory data={data} page={page} limit={6} paginate={paginate} />
      )}
    </>
  );
};
